import { atom } from "recoil";

export const chatSelectedState = atom({
  key: "chatSelected",
  default: {},
});
